module.exports = __webpack_public_path__ + "static/img/bell.45e406b3.png";